<template>
  <div class="remind">
    <el-dialog title="理赔提醒"
      :visible.sync="params.flag"
      v-dialogDrag
      :modal="false"
      width="30%"
               custom-class="warn"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :modal-append-to-body=false
      ref="jsfxRef"
      :before-close="() => params.flag && $parent.toggleProductView('UnitInsure')"
    >
<!--      <div class="search"><i></i><input v-model="search" placeholder="请输入监测点名称"/></div>-->
      <div class="list">
        <div class="list-wrap">
          <el-table :data="
            tableData.filter(
              (data) =>
                !search ||
                data.objname.toLowerCase().includes(search.toLowerCase())
            )
          " height="100%" style="width: 100%" header-row-class-name="r1">
            <el-table-column prop="tiggertime" label="发布时间">
              <template slot-scope="scope">
                {{ $moment(scope.row.ddatetime, "MMM D, YYYY, h:mm:ss A").format('YYYY-MM-DD') }}
              </template>
            </el-table-column>
            <el-table-column prop="objname" label="项目名称">
            </el-table-column>
<!--            <el-table-column prop="bxname" label="保险类型"> </el-table-column>-->
            <el-table-column prop="info" label="理赔内容"> </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>

    <more-detail title="理赔提醒详情" width="40%" :detailDialogVisible="detailDialogVisible"
      :morDetailConfig="morDetailConfig" :detailData="detailData" @changeDialogVisible="detailDialogVisible = false">
    </more-detail>

  </div>
</template>
<script>
import MoreDetail from './module/MoreDetail.vue'
import { mapState } from 'vuex'
export default {
  props: ['params'],
  data () {
    return {
      showRiskList: false,
      dialogTableVisible: false,
      tableData: [],
      search: '',
      rootFontSize: window.rootFontSize,
      detailData: {},
      detailDialogVisible: false,
      morDetailConfig: [
        { label: '监测点名称', field: 'objname' },
        { label: '保险类型', field: 'bxname' },
        { label: '保险等级', field: 'level' },
        { label: '创建时间', field: 'ddatetime' }
      ]
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        if (flag) {
          this.setZindex()
          // 第一遍不显示showRisk
          this.showRiskList && this.$bus.$emit('showInsure', true)
          this.showRiskList = true
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('home', ['bxIndexRecordResult'])
  },
  mounted () {
    this.tableData = this.bxIndexRecordResult
  },
  methods: {
    showMoreDetail (data) {
      this.detailData = data
      this.detailDialogVisible = true
      this.$nextTick(() => {
        this.$refs.fxdRef.setZindex()
      })
    },
    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.jsfxRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  },
  components: {
    MoreDetail
  }

}
</script>
<style lang="less" scoped>
.remind {
  pointer-events: none;
  .bxtx {
    height: 20vh;
  }
  .search {
    width: 30rem;
    height: 2.5rem;
    border-radius: 0.38rem;
    border: 1px solid #52607F;
    display: flex;
    align-items: center;
    margin-bottom: 1.5%;
    background: #0C4170;

    i {
      display: inline-block;
      width: 1.13rem;
      height: 1.06rem;
      background: url("../assets/images/搜索.png") no-repeat;
      background-size: contain;
      margin: 0 0.44rem 0 1rem;
    }

    input {
      height: calc(2.5rem - 2px);
      flex: 1;
      border: 0;
      border-radius: 0.38rem;
      outline: none;
      font-size: 0.88rem;
      color: #FFF;
      background: #0C4170;
    }
    input::placeholder{
      color: #FFF;
    }
  }

  .list {
    flex: 1;
    position: relative;

    .list-wrap {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;

       .el-table {
      background: transparent;
      text-align: center;

         /deep/ .el-table__cell {
           padding:  2px 0;
         }

           /deep/ .r1 .el-table__cell:first-child {
             border-top-left-radius: 10px;
             border-bottom-left-radius: 10px;
           }
           /deep/ .r1 .el-table__cell:nth-child(3) {
             border-top-right-radius: 10px;
             border-bottom-right-radius: 10px;
           }

      /deep/ tr {
        background: transparent;
        th {
          text-align: center;
          border: 0;
          font-size: 0.88rem;
          font-weight: 600;
          color: #FFF;
          background: #0C4170;
        }
        td {
          text-align: center;
          font-size: 0.88rem;
          font-weight: 400;
          color: #FFF;
          border-bottom: 1px solid #316EA3;
        }
        .print {
          width: 1.13rem;
          height: 1.13rem;
          background: url("../assets/images/打印.png") no-repeat;
          border: 0;
          cursor: pointer;
          background-size: 1.13rem 1.13rem;
        }
        .image{
          margin: 0.52vw;
          width: 1.09vw;
          cursor: pointer;
        }
      }
      /deep/ tr:hover td{
          //background: #0C4170 !important;
        background: transparent !important;
      }

      .new{
        margin-left: 0.52vw;
        background-color: #f56c6c;
        border-radius: 0.32vw;
         color: #fff;
         display: inline-block;
         font-size: 0.43vw;
         height: 0.94vw;
         line-height: 0.94vw;
         padding: 0.1vw 0.31vw;
         text-align: center;
         white-space: nowrap;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #273458;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #1b2230;
      }

      /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #0C4170;
      }
      /deep/.el-table__fixed-right-patch {
        background: #1F2C49;
        border: 0;
      }
    }

      .el-table::before {
        background: transparent;
      }
    }
  }
    /deep/.el-dialog__wrapper {
      overflow: hidden;
      .el-dialog {
        pointer-events: auto;
      }
    }
}
</style>
